import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const BENEFITCARD_LOADING = 'BENEFITCARD_LOADING'
export const BENEFITCARD_SUCCESS = 'BENEFITCARD_SUCCESS'
export const BENEFITCARD_FAILED = 'BENEFITCARD_FAILED'

export const fetchBenefitCard = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/BenefitCard`,
        prefix: 'BENEFITCARD',
        method: 'get'
      }
    })
  }
}

export const STAFF_BENEFITCARD_LOADING = 'STAFF_BENEFITCARD_LOADING'
export const STAFF_BENEFITCARD_SUCCESS = 'STAFF_BENEFITCARD_SUCCESS'
export const STAFF_BENEFITCARD_FAILED = 'STAFF_BENEFITCARD_FAILED'

export const fetchStaffBenefitCard = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/BenefitCard/render`,
        prefix: 'STAFF_BENEFITCARD',
        method: 'get'
      }
    })
  }
}

export const STAFF_BACK_BENEFITCARD_LOADING = 'STAFF_BACK_BENEFITCARD_LOADING'
export const STAFF_BACK_BENEFITCARD_SUCCESS = 'STAFF_BACK_BENEFITCARD_SUCCESS'
export const STAFF_BACK_BENEFITCARD_FAILED = 'STAFF_BACK_BENEFITCARD_FAILED'

export const fetchStaffBenefitCardBack = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/BenefitCard/render?renderback=true`,
        prefix: 'STAFF_BACK_BENEFITCARD',
        method: 'get'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/benefitCardActions.js